/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import { Router } from '~/components/Router';

/**
 * Local Imports
*/

import { AbilityProvider } from '../../Providers';
import { IndexAbility, ShowAbility } from '../../Views/Abilities';

/**
 * Exports
*/

/**
 * 
 */
export function AbilityRouter(props) {
  return (
    <Router
      provider={ AbilityProvider }
      routes={[
        {
          path: '/:id',
          component: ShowAbility
        },
        {
          path: '',
          component: IndexAbility
        }
      ]}
    />
  );
}